module.exports = __webpack_public_path__ + "fonts/Chivo-Bold.44169c4.ttf";